import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellularPromotionBlockData from 'Models/Content/CellularPromotionBlockData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {Container} from 'reactstrap';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';

const CellularPromotionBlock = ({data, context}: ComponentProps<CellularPromotionBlockData>) => {
  return (
    <div
      className='CellularPromotionBlock'
      {...getBackgroundImageProps(isMobile ? data.mobileBackGroundImage : data.backGroundImage, context)}>
      <Container>
        <h2 className='CellularPromotionBlock__title'>{data.title?.value}</h2>
        <div className='CellularPromotionBlock__container'>
          <div className='CellularPromotionBlock__packages'>
            <ContentArea noWrap context={context} data={data.packages} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CellularPromotionBlock;
